
// vocabulary/index.ts - Main export file
import { VocabularySet } from './types';
import { elementary } from './elementary';
import { middle } from './middle';
import { high } from './high';
import { science } from './science';
import { mathematics } from './mathematics';
import { literature } from './literature';
import { history } from './history';

// Combine all vocabulary sets
export const vocabularySets: VocabularySet = {
  elementary,
  middle,
  high,
  science,
  mathematics,
  literature,
  history,
};

// Display names for categories
export const categoryDisplayNames: { [key: string]: string } = {
  elementary: "Elementary School",
  middle: "Middle School", 
  high: "High School",
  science: "Science Terms",
  mathematics: "Mathematics",
  literature: "Literature",
  history: "History",
};

// Helper function to get formatted category name
export const formatCategoryName = (category: string): string => {
  return categoryDisplayNames[category] || category.charAt(0).toUpperCase() + category.slice(1);
};

// Export types for use in other files
export type { VocabPair, VocabularySet } from './types';